import { render, staticRenderFns } from "./pointsToTag.vue?vue&type=template&id=945f7be8&scoped=true&"
import script from "./pointsToTag.vue?vue&type=script&lang=js&"
export * from "./pointsToTag.vue?vue&type=script&lang=js&"
import style0 from "./pointsToTag.vue?vue&type=style&index=0&id=945f7be8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945f7be8",
  null
  
)

export default component.exports